import { render } from "./ParentInput.vue?vue&type=template&id=04f9bc4d&scoped=true"
import script from "./ParentInput.vue?vue&type=script&lang=js"
export * from "./ParentInput.vue?vue&type=script&lang=js"

import "./ParentInput.vue?vue&type=style&index=0&id=04f9bc4d&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f9bc4d"]])

export default __exports__